export enum StorageKey {
    BOPIS_STORE = 'slt_bopis_store',
    SDD_STORE = 'slt_sdd_store',
    SDD_ADDRESS = 'slt_sdd_address',
    USER_ADDRESS = 'slt_user_address',
    USER_POSTAL_CODE = 'slt_user_postal_code',
    STORE_ID = 'storeID',
    COMPARE_PRODUCTS = 'slt_compare_products',
    LAST_VIEWED_PLP_URL = 'slt_last_viewed_plp_url',
    CULINARY_CLASS_PREFERRED_STORE = 'culinary_class_preferred_store',
    ADD_PRODUCT_ID_TO_WISHLIST = 'slt_add_product_id_to_wishlist',
    PLP_PRODUCT_ID_SELECTED = 'slt_plp_product_id_selected',
    PREVIEW_MODE_DATE = 'slt_preview_mode_date',
}
